export const FETCH_RESOURCES_REQUEST = 'resources/FETCH_RESOURCES_REQUEST';
export const FETCH_RESOURCES_COMPLETED = 'resources/FETCH_RESOURCES_COMPLETED';
export const FETCH_RESOURCES_FAILED = 'resources/FETCH_RESOURCES_FAILED';

export const SET_DOWNLOAD_BUTTON_LOADING = 'resources/SET_DOWNLOAD_BUTTON_LOADING';
export const SET_WRONG_DOWNLOAD_MODAL = 'resources/SET_WRONG_DOWNLOAD_MODAL';
